import React from 'react';
import { Field, ErrorMessage } from 'formik';
import styles from 'css_modules/Input.module.css';

export const Input = ({
    children,
    className = '',
    disabled,
    inputClass = '',
    isHidden,
    isRequired,
    highlighted,
    noErrorPlaceholder,
    ...props
}) => {
    const labelClass = `
        ${className}
        ${isHidden ? styles.hidden : styles.plainText}
    `;

    return (
        <label className={labelClass}>
            {children}
            {isRequired && !disabled && (
                <span title="Povinné pole" className={styles.asterisk}>*</span>
            )}

            <div
                className={`${styles.inputContainer} ${
                    highlighted ? styles.errorBorder : ''
                } ${disabled ? styles.disabled : ''}`}
            >
                <Field
                    className={`${styles.input} ${inputClass}`}
                    disabled={disabled}
                    {...props}
                />
            </div>

            {!noErrorPlaceholder && (
                <div className={styles.errorPlaceholder}>
                    <ErrorMessage name={props.name}>
                        {data =>
                            Array.isArray(data)
                                ? data.map((err, i) => (
                                    <p key={i} className={styles.error}>{err}</p>
                                ))
                                : <p className={styles.error}>{data}</p>
                        }
                    </ErrorMessage>
                </div>
            )}
        </label>
    );
};
